import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LazyDialogWrapperComponent } from 'src/app/shared/components/lazy-dialog-wrapper/lazy-dialog-wrapper.component';
import { ProfileVendorModel } from '../profile-vendor.model';

let editProfileVendorComponentPromise: Promise<any> | null = null;

/**
 * Starts downloading the edit dialog chunk without opening a dialog.
 * Repeated calls share the same promise and downloaded chunk.
 */
export function preloadEditProfileVendorDialog(): Promise<any> {
  if (!editProfileVendorComponentPromise) {
    editProfileVendorComponentPromise = import('./edit-profile-vendor.module')
      .then(module => module.EditProfileVendorComponent);
  }

  return editProfileVendorComponentPromise;
}

/**
 * Opens the edit form through the standard lazy dialog shell.
 */
export function openEditProfileVendorDialog(
  dialog: MatDialog,
  model: ProfileVendorModel,
  loadPromise: Promise<any> = preloadEditProfileVendorDialog()
): MatDialogRef<any> {
  return dialog.open(LazyDialogWrapperComponent, {
    height: '100vh',
    width: '600px',
    panelClass: 'dialog-detail',
    data: {
      loadFn: () => loadPromise,
      componentData: {
        model
      },
      dialogOptions: {
        position: { right: '0' }
      }
    }
  });
}
